import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import funder1 from "../assets/founder1.jpg";
import funder2 from "../assets/founder2.jpg";
import funder3 from "../assets/founder3.png";
import funder4 from "../assets/founder4.png";
import funder5 from "../assets/founder5.jpg";
import funder6 from "../assets/founder6.jpg";

const OurFunders = () => {
  const funders = [
    funder1,
    funder2,
    funder3,
    funder4,
    funder5,
    funder6,
  ];

  return (
    <section className="py-16 bg-gray-800 text-white">
      <div className="w-11/12 md:w-4/5 mx-auto text-center">
        <h2 className="text-3xl font-bold text-lime-400 mb-10">
          OUR SUPPORTERS
        </h2>

        <Swiper
          modules={[Autoplay]}
          spaceBetween={40}
          slidesPerView={2}
          loop={true}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          speed={1000}
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 50,
            },
            1280: {
              slidesPerView: 5,
              spaceBetween: 60,
            },
          }}
        >
          {funders.map((logo, i) => (
            <SwiperSlide
              key={i}
              className="flex justify-center items-center"
            >
              <img
                src={logo}
                alt={`Supporter ${i + 1}`}
                className="h-28 md:h-36 object-contain"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default OurFunders;